// API helper for Emergency -> IPD conversion (G11 Part A). Tenant headers are
// sent explicitly on every call — see ipdEnhancementsApi.js. Standalone form
// only; src/pages/emergency/* (mock module) is not touched or linked here.

import axios from "axios";

const BASE =
  process.env.REACT_APP_BACKEND_ROUTE_URL ||
  "https://manage-dev.hlthtek.com/app/api/";

function authHeaders(extra = {}) {
  const token = sessionStorage.getItem("accessToken") || "";
  return {
    Authorization: `Bearer ${token}`,
    "APP-MODE": sessionStorage.getItem("APP_MODE") || "",
    "ORG-CODE": sessionStorage.getItem("ORG_CODE") || "",
    "USER-ACCESS-KEY": sessionStorage.getItem("USER_ACCESS_KEY") || "",
    USERNAME: sessionStorage.getItem("userName") || "",
    ...extra,
  };
}

export async function convertEmergencyToIpd({
  patientId,
  emergencyVisitId,
  admittingDoctorId,
  assignedDoctorId,
  admissionType,
  admissionDetails,
  payerType,
  governmentScheme,
  corporateName,
  corporateReference,
  insuranceProvider,
  insurancePolicyNo,
  tpaName,
}) {
  const body = {
    patient_id: patientId,
    admitting_doctor_id: admittingDoctorId,
  };
  if (emergencyVisitId) body.emergency_visit_id = emergencyVisitId;
  if (assignedDoctorId) body.assigned_doctor_id = assignedDoctorId;
  if (admissionType) body.admission_type = admissionType;
  if (admissionDetails) body.admission_details = admissionDetails;
  if (payerType) body.payer_type = payerType;
  if (governmentScheme) body.government_scheme = governmentScheme;
  if (corporateName) body.corporate_name = corporateName;
  if (corporateReference) body.corporate_reference = corporateReference;
  if (insuranceProvider) body.insurance_provider = insuranceProvider;
  if (insurancePolicyNo) body.insurance_policy_no = insurancePolicyNo;
  if (tpaName) body.tpa_name = tpaName;

  const res = await axios.post(`${BASE}emergency_to_ipd/`, body, {
    headers: authHeaders({ "Content-Type": "application/json" }),
  });
  return res?.data;
}
